<template>
  <div>
    <b-modal
      id="staff-img-modal"
      ref="staff-img-modal-ref"
      hide-footer
      title="Consultant Bio Picture"
    >
      <FlashMessage />
      <b-form @submit.stop.prevent="onSubmit">
        <div class="d-flex mb-3">
          <b-form-file v-model="image" placeholder="Choose an image" class="w-auto flex-grow-1"></b-form-file>
          <b-button v-if="hasImage" variant="danger" class="ml-3" @click="clearImage">Clear image</b-button>
        </div>

        <b-img v-if="hasImage" :src="imageSrc" class="mb-3" fluid block rounded></b-img>

        <b-button :disabled="!hasImage" variant="primary" type="submit">Upload image</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import FlashMessage from "@/partials/flash-message"

const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export default {
  components: {
    FlashMessage
  },
  data() {
    return {
      image: null,
      imageSrc: null
    };
  },
  computed: {
    hasImage() {
      return !!this.image;
    },
    ...mapGetters({
      staffData: 'staff/getData'
    })
  },
  watch: {
    image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.imageSrc = value;
            })
            .catch(() => {
              this.imageSrc = null;
            });
        } else {
          this.imageSrc = null;
        }
      }
    }
  },
  methods: {
    clearImage() {
      this.image = null;
    },

    onSubmit() {
      if (!this.image) {
        return;
      }
      // const formData = new FormData();
      // formData.append("picture", this.imageSrc);
      // formData.append("domsessid", this.staffData.domsessid);
      this.upload({
        picture: this.imageSrc,
        domsessid: this.staffData.domsessid
      })
      this.clearImage()
      setTimeout(() => {
        this.$refs["staff-img-modal-ref"].hide();
      }, 3000)  
    },
    ...mapActions({
      upload: 'staff/uploadConsultantImageAction',
    }),
    showModal(){
      this.$refs["staff-img-modal-ref"].show();
    },
  }
};
</script>

<style>
</style>
